// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  phase: __t.u8(),
  ready: __t.array(__t.identity()),
  partyId: __t.u64().name("party_id"),
  instanceId: __t.u64().name("instance_id"),
  encounterId: __t.u64().name("encounter_id"),
  outcomeRow: __t.option(__t.u8()).name("outcome_row"),
  campaignOffer: __t.u64().name("campaign_offer"),
  heroes: __t.array(__t.u64()),
});
